import ProjectAdditionalFilters from "@/entities/scheduler/additionalFiltersInterfaces/ProjectAdditionalFilters";

const projectViewFiltersTemplate: ProjectAdditionalFilters = {
  countries: [],
  states: [],
  cities: [],
  criteria: [],
  projects: [],
  // address: [],
  status: [{ id: "All", name: "All" }],
};

export default projectViewFiltersTemplate;
